import styled from '@emotion/styled';

export const ModalContentWrapper = styled.div`
	width: 100%;
	height: 500px;
	position: relative;
	overflow: hidden;

	.webview {
		width: 100%;
		height: 100%;
		border: none;
	}
`;

export const LoadingOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10;
`;
